import React from 'react'
import './home.css'
import person from '../../images/person.svg'

import { Link } from 'react-router-dom'
import apply from '../../images/apply-icon.svg'
import feedback from '../../images/feedback-icon.svg'
import jobnotify from '../../images/job-notification-icon.svg'
import skills from '../../images/Skills.svg'
import { Testimonies } from '../../data'

import JobOpportunity from '../../images/job-opportunity.svg'
import Training from '../../images/Training.svg'
import PageNavbar from '../../components/navbar/Navbar'
import { Row, Col, Container, Card, Image, Button} from 'react-bootstrap'


const Home = () => {
  return (
    <div>
      < PageNavbar/>
      <Container fluid className='pt-3' style={{backgroundColor: 'rgba(255, 161, 94, 0.55)'}}>
      
      <Row noGutters className='ps-5'>
        
        <Col md={7}  className='my-auto ps-3'>
          <Card.Body className=''>
            <Card.Title className='display-5 hero-display-3'>
              Discover New Job Opportunities and Right Talents</Card.Title>
            <br/>
            <Card.Text
            className='hero-display-6 me-5 pe-5 pb-3'> Find the right job for you - All job posts are verified, no scams or junk...
            </Card.Text>
          </Card.Body>
        </Col>
        <Col sm ={8} md={5}>
          <Card.Img
            src={person}
            alt="placeholder" style={{width:'100%', height:'100%'}}
          />
        </Col>
      </Row>
    
      </Container>
      <Card className='p-5 text-center border-0'>
        <Card.Body className=''>
          <Card.Title className='signup-title mb-5 pb-3 '>
            Sign up/ Sign in as a Job Seeker or Employer
          </Card.Title>
          <div className='d-md-flex gap-4 justify-content-center'>
          <Button type='button'  size="lg" className=' btn-1 btn-1-primary' >
          <Link to='/jobseekersignup' className='text-white text-decoration-none' >JobSeeker</Link>
          </Button>
          <Button type='button'  size="lg" className='btn-1 btn-1-secondary'>
          <Link to='/employersignup'className='text-white text-decoration-none '  >Employer</Link>
          </Button>
          </div>
        </Card.Body>
      </Card>
      <Container fluid className='p-5 justify-content-center'style={{backgroundColor: 'rgba(204, 223, 240, 0.2)'}}>
        <p className='help-title text-center'>How Jobbers Lens can help you</p>
        <Row className='text-center justify-content-center pt-5 '>
          <Col md={6} lg={4} className='mt-4'>
            <img src={jobnotify} style={{height: '80px'}}/>
            <p className='mt-4 help-text'>Get Job Alert</p>
          </Col>
          <Col md={6} lg={4} className='mt-4'>
            <img src={apply}/>
            <p className=' help-text'>Apply for Jobs</p>
          </Col>
          <Col md={6} lg={4} className='mt-3 justify-content-center align-items-center'>
            <img src={feedback}/>
            <p className=' help-text px-lg-5' >Receive Feedback on Job applications/ posts</p>
          </Col>
          <Col md={6} className='mt-5'>
            <img src={skills}/>
            <p className='mt-3 help-text px-lg-3' >Find out how well your skills match a Job requirement using our IQ Tests</p>
          </Col>
        </Row>
      </Container>
      <Container fluid className='px-4 py-5 justify-content-center 'style={{backgroundColor: 'rgba(109, 102, 96, 0.3)'}}>
         <p className='text-center help-title'>See what our users have to say about us</p>
        <Row className='py-3' xs={1} sm={1} md={2} lg={4}>
          {Testimonies.map((testimony) => {
            const {id, name, type, info, testimonyImage} = testimony;
            return(
              <Col key={id} className='mt-3'> 
                <Card className='border-0 p-0 m-0 testimony-card' style={{width:'100%', height:'100%'}} >
                  <Card.Img src={testimonyImage} style={{width:'96px', height:'120px'}} className='mx-auto px-auto mt-2'/>
                  <Card.Body>
                    <Card.Title className='testimony-info'>
                      {info}
                    </Card.Title>
                    <br/>
                    <Card.Text className='testimony-name pt-md-2'>
                      {name} &nbsp; - &nbsp;
                      <span className='testimony-span'><b>{type}</b></span>
                    
                    </Card.Text>
                  </Card.Body>

                </Card>
              </Col>
            )
          })}

        </Row>

      </Container>
      <Container fluid style={{backgroundColor: '#F5F9FC'}} className='p-0 m-0'>
          <Row className='p-0 m-0'>
            <Col xs={12} sm={12} md={4}className='p-0 m-0'>
             <img src={JobOpportunity} alt='' style={{width:'100%', height:'100%'}}/>
            </Col>
            <Col xs={12} sm={12}md={8}className='my-5 justify-content-center'>
              <p className='text-center section-4-header'>Career Development and Advice</p>
              <div className='pt-4 px-4'>
                <div className='d-flex align-items-center '>
                <img src={skills} alt=''/>
                <p className='icon-text'>Take skill assessments to improve your chances with skills in demand by the job market</p>
                </div>
                <div className='d-flex  mt-2 align-items-center'>
                <img style={{width: '135px'}}src={Training} alt=''/>
                 <p className='icon-text ms-lg-2 ms-4'>Get recommendations in training or webinars</p>
                </div>
              </div>
              <Row className=' justify-content-center'>
                <Col  sm= {6} md={6} className=''>
                 <Card className='align-items-center mt-5 mx-5 mx-md-0 px-4 py-3 inner-card' style={{width:'auto'}}>
                  <div className='text-center align-items-center justify-content-center'>
               <p className='inner-card-text'>Create a Profile to unlock these key features</p>
               <Link to='/jobseekersignup' className='mt-5 btn-1 btn-1-tertiary mx-auto'>
               Sign up</Link>
              </div>
                 </Card>
                </Col>
              </Row>
            
            </Col>
          </Row>
      </Container>
  
    </div>
  )
}

export default Home
